
const URLS = [
    {
        name: "wuye_finance_refund_apply", //退款
        level: 1,
        url: '/finance/wuyeFinanceRefundApply/startFlow'
    },
    {
        name: "wuye_finance_derated_apply", //减免
        level: 1,
        url: '/finance/wuyeFinanceDerated/startFlow'
    },
    {
        name: "wuye_patrol_plan", //巡逻计划
        level: 1,
        url: '/patrol/wuyePatrolPlan/startFlow'
    },
    {
        name: "wuye_patrol_route", //巡逻路线
        level: 1,
        url: '/patrol/wuyePatrolRoute/startFlow'
    },
    {
        name: "wuye_quality_plan", //品质计划
        level: 1,
        url: '/quality/wuyeQualityPlan/startFlow'
    },
    {
        name: "wuye_equipment_annual_inspection_record", //设备年检
        level: 1,
        url: '/equipment/wuyeEquipmentAnnualInspection/startFlow'
    },
    {
        name: "wuye_equipment_maintenance", //设备维保
        level: 1,
        url: '/equipment/wuyeEquipmentMaintenance/startFlow'
    },
    {
        name: "wuye_quality_task", //品质任务
        level: 1,
        url: '/quality/wuyeQualityTask/startFlow'
    },

    {
        name: "wuye_decorate_info", //装修
        level: 1,
        url: '/decorate/wuyeDecorateInfo/startFlow'
    },
    {
        name: 'wuye_decorate_info_waterproof_acceptance', // 装修防水验收
        level: 1,
        url: '/decorate/wuyeDecorateInfoWaterproofAcceptance/startFlow'
    },
    {
        name: "wuye_decorate_info_acceptance", //装修完工验收
        level: 1,
        url: '/decorate/wuyeDecorateInfoAcceptance/startFlow'
    },
    {
        name: "wuye_quality_rectify", //品质整改
        level: 1,
        url: '/quality/wuyeQualityRectify/startFlow'
    },
    {
        name: "wuye_small_community_consultation", //小区资讯
        level: 1,
        url: '/small/wuyeSmallCommunityConsultation/startFlow'
    },
    {
        name: "wuye_small_notification", //通知公告
        level: 1,
        url: '/small/wuyeSmallNotification/startFlow'
    },
    {
        name: "wuye_archive_info", //档案信息目录
        level: 1,
        url: '/archive/wuyeArchiveInfo/startFlow'
    },
    {
        name: "wuye_archive_type", //档案类别目录
        level: 1,
        url: '/archive/wuyeArchiveType/startFlow'
    },
    {
        name: "wuye_extension_bid", //招投标管理
        level: 1,
        url: '/extension/wuyeExtensionBid/startFlow'
    },
    {
        name: "wuye_extension_survey", //项目调研
        level: 1,
        url: '/extension/wuyeExtensionSurvey/startFlow'
    },
    {
        name: "wuye_handover_doc", //资料交接
        level: 1,
        url: '/handover/wuyeHandoverDoc/startFlow'
    },
    {
        name: "wuye_handover_withdrawal", //项目交接
        level: 1,
        url: '/handover/wuyeHandoverWithdrawal/startFlow'
    },
    {
        name: "wuye_infacy_project_reception", //项目接收
        level: 1,
        url: '/infacy/wuyeInfacyProjectReception/startFlow'
    },
    {
        name: "wuye_base_corp_info",  // 业务单位信息目录
        level: 1,
        url: '/base/wuyeBaseCorpInfo/startFlow'
    },
    {
        name: 'wuye_equipment_archive', // 设备信息档案
        level: 1,
        url: '/equipment/wuyeEquipmentArchive/startFlow'
    },
    {
        name: 'wuye_equipment_plan', // 设备巡检计划
        level: 1,
        url: '/equipment/wuyeEquipmentPlan/startFlow'
    },
    {
        name: 'wuye_quality_inspection_standard', // 品质检查标准
        level: 1,
        url: '/quality/wuyeQualityInspectionStandard/startFlow'
    },
    {
        name: 'wuye_finance_receipt_master', // 收据管理（领用）
        level: 1,
        url: '/finance/wuyeFinanceReceiptMaster/startFlow'
    },
    {
        name: 'wuye_daily_notice', // 物业通知管理
        level: 1,
        url: '/daily/wuyeDailyNotice/startFlow'
    },
    {
        name: 'wuye_base_project', // 物业项目信息
        level: 1,
        url: '/base/wuyeBaseProject/startFlow'
    },
    {
        name: 'wuye_daily_check', // 双随机检查管理
        level: 1,
        url: ''
    },
    {
        name: 'wuye_daily_emergency', // 突发事件处理
        level: 1,
        url: '/daily/wuyeDailyCheck/startFlow'
    },
    {
        name: 'wuye_base_house_type', // 物业类型
        level: 1,
        url: '/base/wuyeBaseHouseType/startFlow'
    },
    {
        name: 'wuye_base_customer_type', // 客户类型
        level: 1,
        url: '/base/wuyeBaseCustomerType/startFlow'
    },
    {
        name: 'wuye_base_fee_item', // 收费项目
        level: 1,
        url: '/base/wuyeBaseFeeItem/startFlow'
    },
    {
        name: 'wuye_base_fee_norm', // 收费标准
        level: 1,
        url: '/base/wuyeBaseFeeNorm/startFlow'
    },
    {
        name: 'wuye_base_car', // 车辆信息
        level: 1,
        url: '/base/wuyeBaseCar/startFlow'
    },
    {
        name: 'wuye_customer_project', // 客户基本信息目录
        level: 1,
        url: '/base/wuyeBaseCustomerProject/startFlow'
    },
    {
        name: 'wuye_order_handover', // 秩序维护交接班管理
        level: 1,
        url: '/daily/wuyeDailyOrderHandover/startFlow'
    },
    {
        name: 'wuye_order_monitor', // 秩序维护监控室值班管理
        level: 1,
        url: '/daily/wuyeDailyOrderMonitor/startFlow'
    },
    {
        name: 'wuye_base_building', // 物业构成楼栋信息
        level: 1,
        url: '/base/wuyeBaseBuilding/startFlow'
    },
    {
        name: 'wuye_base_house', // 物业构成信息
        level: 1,
        url: '/base/wuyeBaseHouse/startFlow'
    },
    {
        name: 'wuye_finance_derated', // 批量减免、单价减免
        level: 1,
        url: '/finance/wuyeFinanceDerated/startFlow'
    },
    {
        name: 'wuye_input_basis_info', // 录入依据档案信息目录
        level: 1,
        url: '/input/wuyeInputBasisInfo/startFlow'
    },
    {
        name: 'wuye_base_meter_info',  // 计量表信息目录
        level: 1,
        url: '/base/wuyeBaseMeterInfo/startFlow'
    },
    {
        name:'wuye_base_meter_change', // 计量表换表管理
        level: 1,
        url: '/base/wuyeBaseMeterChange/startFlow'
    },
    {
        name: 'wuye_finance_handover_doc', // 财务资料交接
        level: 1,
        url: '/handover/wuyeFinanceHandoverDoc/startFlow'
    },
    {
        name: 'wuye_param_meter_type', // 计量表类型
        level: 1,
        url: '/param/meter/wuyeParamMeterType/startFlow'
    },
    {
        name: 'wuye_base_project_photo', // 项目图库类别
        level: 1,
        url: '/base/wuyeBaseProjectPhoto/startFlow'
    },
    {
        name: 'wuye_base_general_template_category', // 通用模版类别
        level: 1,
        url: '/daily/wuyeBaseGeneralTemplateCategory/startFlow'
    },
    {
        name: 'wuye_base_general_template', // 通用模版管理
        level: 1,
        url: '/template/wuyeBaseGeneralTemplate/startFlow'
    },
    {
        name: 'wuye_base_project_map', // 项目图库信息
        level: 1,
        url: '/base/wuyeBaseProjectMap/startFlow'
    },
    {
        name: 'wuye_points_gift', // 礼品设置
        level: 1,
        url: '/points/wuyePointsGift/startFlow'
    },
    {
        name: 'wuye_decorate_rectify', // 违章整改管理
        level: 1,
        url: '/decorate/wuyeDecorateRectify/startFlow'
    },
    {
        name: 'wuye_decorate_garbage_clear', // 装修垃圾清运
        level: 1,
        url: '/decorate/wuyeDecorateGarbageClear/startFlow'
    },
    {
        name: 'wuye_custserv_base', // 客服报事
        level: 1,
        url: '/custserv/wuyeCustservBase/startFlow'
    },
    {
        name: 'wuye_custserv_complaint', // 投诉管理
        level: 1,
        url: '/custserv/wuyeCustservComplaint/startFlow'
    },
    {
        name: 'wuye_custserv_maintain', // 维修管理
        level: 1,
        url: '/custserv/wuyeCustservMaintain/startFlow'
    },
    {
        name: 'wuye_know_type', // 知识库类别
        level: 1,
        url: '/know/wuyeKnowType/startFlow'
    },
    {
        name: 'wuye_base_house_delivery', // 物业构成-交付信息
        level: 1,
        url: '/base/wuyeBaseHouseDelivery/startFlow'
    },
    {
        name: 'wuye_base_house_customer', // 物业构成-客户列表
        level: 1,
        url: '/base/wuyeBaseHouseCustomer/startFlow'
    },
    {
        name: 'wuye_base_house_fee_norm',
        level: 1,
        url: '/base/wuyeBaseHouseFeeNorm/startFlow'                        // 物业构成-收费标准
    },
    {
        name: 'wuye_small_banner', // 小程序-轮播图
        level: 1,
        url: '/carousechart/wuyeSmallCarousechart/startFlow'
    },
    {
        name: 'wuye_small_surround', // 小程序-周边配套/物业手册/装修资料
        level: 1,
        url: '/small/wuyeSmallSurround/startFlow'
    },
    {
        name: 'wuye_daily_order_firefighting', // 日常管理-秩序维护消控室值班管理
        level: 1,
        url: '/daily/wuyeDailyOrderFirefighting/startFlow'
    },
    {
        name: 'wuye_daily_virescence', // 日常管理-绿化种植养护
        level: 1,
        url: '/daily/wuyeDailyVirescence/startFlow'
    },
    {
        name: 'shye_contract_derated', // 合同减免
        level: 1,
        url: '/shye/contract/shyeContractDerated/startFlow'
    },
    {
        name: 'shye_contract', // 合同
        level: 1,
        url: '/contract/shyeContract/startFlow'
    },
    {
        name: 'shye_contract_change', // 合同变更
        level: 1,
        url: '/contract/shyeContractChange/startFlow'
    },
    {
        name: 'shye_leasing_resources_appy', // 单价标准
        level: 1,
        url: '/shye/base/shyeLeasingResourcesAppy/startFlow'
    },
    {
        name: 'shye_property', // 产权信息
        level: 1,
        url: '/shye/base/shyeProperty/startFlow'
    },
    {
        name: 'shye_march_into', // 进场
        level: 1,
        url: '/shye/contract/shyeMarchInto/startFlow'
    },
    {
        name: 'shye_march_out', // 撤场
        level: 1,
        url: '/shye/contract/shyeMarchOut/startFlow'
    },
    {
        name: 'shye_march_out_retention', // 撤场
        level: 1,
        url: '/shye/contract/shyeMarchOutStuff/startFlow'
    },
    {
        name: 'shye_customer', // 招商客户
        level: 1,
        url: '/shye/base/shyeCustomerInfo/startFlow'
    },
    {
        name: 'shye_brand', // 品牌
        level: 1,
        url: '/shye/base/brand/startFlow'
    },
    {
        name: 'shye_market', // 市场调研
        level: 1,
        url: '/shye/base/marketResearch/startFlow'
    },
    {
        name: 'shye_lease', // 意向单
        level: 1,
        url: '/leasing/shyeLease/startFlow'
    },
    {
        name: 'shye_switch_room', // 高配间
        level: 1,
        url: '/shye/daily/shyeSwitchRoom/startFlow'
    },
    {
        name: 'know_info', // 知识库信息目录
        level: 1,
        url: '/know/wuyeKnowInfo/startFlow'
    },
    {
        name: 'shye_decorate_rectify', // 违章整改
        level: 1,
        url: '/shye/decorate/wuyeDecorateRectify/startFlow'
    },
    {
        name: 'shye_decorate_garbage_clear', // 建筑垃圾
        level: 1,
        url: '/shye/decorate/wuyeDecorateGarbageClear/startFlow'
    },
    {
        name: 'shye_build_garbage_clear', // 装修垃圾
        level: 1,
        url: '/shye/decorate/shyeBuildGarbageClear/startFlow'
    },
    {
        name: 'shye_custserv', // 客服报事
        level: 1,
        url: '/custserv/shyeCustservBase/startFlow'
    },
    {
        name: 'shye_complaint', // 投诉管理
        level: 1,
        url: '/custserv/shyeCustservComplaint/startFlow'
    },
    {
        name: 'shye_maintain', // 维修管理
        level: 1,
        url: '/custserv/shyeCustservMaintain/startFlow'
    },
    {
        name: 'shye_leasing_resources', // 租赁资源
        level: 1,
        url: '/contract/shyeLeasingResources/startFlow'
    },
    {
        name: 'shye_finance_adjust', // 单价调减
        level: 1,
        url: '/finance/shyeFinanceReceivableAdjust/startFlow'
    },
    {
        name: 'shye_finance_staging', // 单价分期
        level: 1,
        url: '/shye/finance/shyeFinanceReceivableStaging/startFlow'
    },
    {
        name: 'shye_green_plan', // 绿化养护计划管理
        level: 1,
        url: '/shye/daily/shyeGreenPlan/startFlow'
    },
    {
        name: 'shye_green_reseed', // 绿化补种信息管理
        level: 1,
        url: '/shye/daily/shyeGreenReseed/startFlow'
    },
    {
        name: 'wuye_infacy_main',
        level: 1,
        url: '/infacy/wuyeInfacyMain/startFlow'
    },
    {
        name: 'shye_fee_assessment',
        level: 1,
        url: '/shye/report/shyeFeeAssessment/startFlow'
    },
    //<--------------- 以下为物料管理系统页面 --------------->
    {
        name: 'materApplybill', // 要料
        level: 1,
        url: ''
    },
    {
        name: 'materApplybillPrice', // 要料单价预审
        level: 1,
        url: ''
    },
    {
        name: 'materApplybill_detail', // 要料
        level: 1,
        url: ''
    },
    {
        name: 'materContract', // 合同
        level: 1,
        url: ''
    },
    {
        name: 'materContract_detail', // 物料台账
        level: 1,
        url: ''
    },
    {
        name: 'materWarehouse', // 入库
        level: 1,
        url: ''
    },
    {
        name: 'materWarehouse_detail', // 入库
        level: 1,
        url: ''
    },
    {
        name: 'materReceipt', // 收料
        level: 1,
        url: ''
    },
    {
        name: 'materReceipt_receInvos_detail', // 收料
        level: 1,
        url: ''
    },
    {
        name: 'materReceipt_receivingSubs_detail', // 收料
        level: 1,
        url: ''
    },
    {
        name: 'materExWarehouse', // 出库
        level: 1,
        url: ''
    },
    {
        name: 'materExWarehouse_detail', // 出库
        level: 1,
        url: ''
    },
    {
        name: 'materPicking', // 领料
        level: 1,
        url: ''
    },
    {
        name: 'materPicking_detail', // 领料
        level: 1,
        url: ''
    },
    {
        name: 'materContractAdjust', // 补充合同
        level: 1,
        url: ''
    },
    {
        name: 'materContractAdjust_detail', // 补充合同
        level: 1,
        url: ''
    },
    {
        name: 'materContractMaterAdjust', // 合同物料调整单
        level: 1,
        url: ''
    },
    {
        name: 'materContractMaterAdjust_detail', // 合同物料调整单
        level: 1,
        url: ''
    },
    {
        name: 'materBudget', // 预算
        level: 1,
        url: ''
    },
    {
        name: 'materBudget_detail', // 预算
        level: 1,
        url: ''
    },
    {
        name: 'materBudgetAdjust', // 预算调整
        level: 1,
        url: ''
    },
    {
        name: 'materBudgetAdjust_detail', // 预算调整
        level: 1,
        url: ''
    },
    {
        name: 'materSupplierBudget', // 施工单位要料预算
        level: 1,
        url: ''
    },
    {
        name: 'materSupplierBudget_detail', // 施工单位要料预算
        level: 1,
        url: ''
    },
    {
        name: 'materSupplierBudgetAdjust', // 施工单位要料预算调整
        level: 1,
        url: ''
    },
    {
        name: 'materSupplierBudgetAdjust_detail', // 施工单位要料预算调整
        level: 1,
        url: ''
    },
    //<--------------- 以下为费控管理系统 --------------->
    {
        name: 'cost_budget_preparation', // 年度支出预算编制
        level: 1,
        url: '/budget/costBudgetPreparation/annual/startFlow'
    },
    {
        name: 'cost_budget_preparation_adjustment', // 年度支出预算调整
        level: 1,
        url: '/budget/costBudgetPreparationAdjustment/startFlow'
    },
    {
        name: 'cost_contract_info', // 支出合同登记3
        level: 1,
        url: '/contract/costContractInfo/startFlow'
    },
    {
        name: 'cost_contract_adjustment_payment_plan', // 支出合同付款计划调整
        level: 1,
        url: '/contract/costContractAdjustmentPaymentPlan/startFlow'
    },
    {
        name: 'cost_contract_workload_estimate', // 单价合同工作量核定
        level: 1,
        url: '/contract/costContractWorkloadEstimate/startFlow'
    },
    {
        name: 'cost_contract_settlement', // 支出合同结算
        level: 1,
        url: '/contract/costContractSettlement/startFlow'
    },
    {
        name: 'cost_contract_deduction', // 支出合同扣款
        level: 1,
        url: '/contract/costContractDeduction/startFlow'
    },
    {
        name: 'cost_contract_warranty', // 支出合同质保
        level: 1,
        url: '/cost/contract/costContractWarranty/startFlow'
    },
    {
        name: 'cost_event_info', // 事项单登记
        level: 1,
        url: '/payment/costEventInfo/startFlow'
    },
    {
        name: 'cost_event_adjust', // 事项单调整
        level: 1,
        url: '/payment/costEventAdjust/startFlow'
    },
    {
        name: 't_invoice', // 发票登记
        level: 1,
        url: '/cost/invoice/startFlow'
    },
    {
        name: 'cost_request_reserve_funds', // 备用金/预付款申请登记
        level: 1,
        url: '/cost/payment/costRequestReserveFunds/startFlow'
    },
    //<--------------- 以下为零星工程系统 --------------->
    {
        name: 'hq_approval_repair_retrofit', // 维修改造立项工程会签
        level: 1,
        url: '/hq/sign/approval/repair/retrofit/startFlow'
    },
    {
        name: 'hq_approval_method_price', // 用工方式及单价会签
        level: 1,
        url: '/hq/hqApprovalMethodPrice/startFlow'
    },
    {
        name: 'lxgc_start_info', // 开工信息
        level: 1,
        url: '/lxgc/lxgcStartInfo/startFlow'
    },
    {
        name: 'lxgc_completion_acceptance', // 完工验收信息
        level: 1,
        url: '/lxgc/lxgcCompletionAcceptance/startFlow'
    },
    {
        name: 'lxgc_completion_settlement', // 完工结算信息
        level: 1,
        url: '/lxgc/lxgcCompletionSettlement/startFlow'
    },
    {
        name: 'lxgc_minor_repair', // 零星报修信息
        level: 1,
        url: '/lxgc/lxgcMinorRepair/startFlow'
    },
    {
        name: 'lxgc_contract_party_jia_confirm', // 合同签订公司确认
        level: 1,
        url: '/lxgc/lxgcContractPartyJiaConfirm/startFlow'
    },
	////<--------------- 以下为合同管理 --------------->
	{
	    name: 'cost_contract_type', // 合同类别
	    level: 1,
	    url: '/contract/costContractType/startFlow'
	},
	{
	    name: 'erp_contract_format', // 格式合同
	    level: 1,
	    url: '/erp/contract/contractFormat/startFlow'
	},
	{
	    name: 'erp_contract_must', // 必须订立合同事项目录
	    level: 1,
	    url: '/erp/contract/base/erpContractMust/startFlow'
	},
	{
	    name: 'erp_contract_sign_role', // 合同订立审批权限
	    level: 1,
	    url: '/erp/contract/base/erpContractSignRole/startFlow'
	},
	{
	    name: 'erp_contract_safe_keep', // 合同保管期限目录
	    level: 1,
	    url: '/erp/contract/base/erpContractSafeKeep/startFlow'
	},
	{
	    name: 'erp_contract_circulation_approval', // 格式合同流转审批
	    level: 1,
	    url: '/erp/contract/info/erpContractCirculationApproval/startFlow'
	},
	{
	    name: 'erp_contract_hq_approval', // 格式合同会签审批
	    level: 1,
	    url: '/erp/contract/info/erpContractHqApproval/startFlow'
	},
	{
	    name: 'erp_contract_new_inner', // 内/外部制定（新）
	    level: 1,
	    url: '/erp/contract/info/erpContractNewInner/startFlow'
	},
	{
	    name: 'erp_contract_new_template', // 合同打印模板设置
	    level: 1,
	    url: '/erp/contract/info/erpContractNewTemplate/startFlow'
	},
	{
	    name: 'erp_contract_use', // 合同利用
	    level: 1,
	    url: '/erp/contract/info/erpContractUse/startFlow'
	},
	{
	    name: 'erp_contract_dispute', // 合同纠纷
	    level: 1,
	    url: '/erp/contract/info/erpContractDispute/startFlow'
	},

    //<--------------- 以下为会签单 --------------->
	{
	    name: 'hq_disposal_items', // 废旧物品处置
	    level: 1,
	    url: '/hq/fee/hqDisposalItems/startFlow'
	},
	{
	    name: 'hq_lxsr_other', // 零星收入其他
	    level: 1,
	    url: '/hq/fee/hqLxsrOther/startFlow'
	},
	{
	    name: 'hq_fee_plan', // 收费方案
	    level: 1,
	    url: '/hq/fee/feePlan/startFlow'
	},
	{
	    name: 'hq_contract_advertisement', // 广告位合同新签
	    level: 1,
	    url: '/hq/leasing/hqContractAdvertisement/startFlow'
	},
	{
	    name: 'hq_contract_advertisement_renew', // 广告位合同续签
	    level: 1,
	    url: '/hq/leasing/hqContractAdvertisementRenew/startFlow'
	},
	{
	    name: 'hq_contract', // 租赁合同新签
	    level: 1,
	    url: '/hq/leasing/hqContract/startFlow'
	},
	{
	    name: 'hq_contract_renew', // 租赁合同续签
	    level: 1,
	    url: '/hq/leasing/hqContractRenew/startFlow'
	},
	{
	    name: 'hq_contract_change', // 租赁合同变更
	    level: 1,
	    url: '/hq/leasing/hqContractChange/startFlow'
	},
	{
	    name: 'hq_lxzc_other', // 零星支出其他
	    level: 1,
	    url: '/hq/lxzc/other/hqLxzcOther/startFlow'
	},
	{
	    name: 'hq_general', // 通用
	    level: 1,
	    url: '/hq/other/general/startFlow'
	},
	{
	    name: 'hq_approval_charge_index_adjust', // 收费指标调整
	    level: 1,
	    url: '/hq/sign/approval/charge/index/adjust/startFlow'
	},
	{
	    name: 'hq_approval_internal_settlement', // 内部结算
	    level: 1,
	    url: '/hq/sign/approval/internal/settlement/startFlow'
	},
	{
	    name: 'hq_approval_parking_fee_reduce', // 停车月租费减免
	    level: 1,
	    url: '/hq/sign/approval/parking/fee/reduce/startFlow'
	},
	{
	    name: 'hq_approval_refund', // 特殊事项退款
	    level: 1,
	    url: '/hq/sign/approval/refund/startFlow'
	},
	{
	    name: 'hq_approval_wuye_fee_reduce', // 收费减免
	    level: 1,
	    url: '/hq/sign/approval/wuye/fee/reduce/startFlow'
	},
	{
	    name: 'hq_approval_advertise_make', // 广告制作安装
	    level: 1,
	    url: '/hq/sign/approval/advertise/make/startFlow'
	},
	{
	    name: 'hq_approval_advertise_promotion', // 广告宣传类
	    level: 1,
	    url: '/hq/sign/approval/advertise/promotion/startFlow'
	},
	{
	    name: 'hq_approval_clear', // 清洁服务
	    level: 1,
	    url: '/hq/sign/approval/clear/startFlow'
	},
	{
	    name: 'hq_approval_commission', // 佣金
	    level: 1,
	    url: '/hq/sign/approval/commission/startFlow'
	},
	{
	    name: 'hq_approval_daily_maintenance', // 日常维修
	    level: 1,
	    url: '/hq/sign/approval/daily/maintenance/startFlow'
	},
	{
	    name: 'hq_gcsg', // 工程施工
	    level: 1,
	    url: '/hq/hqGcsg/startFlow'
	},
	{
	    name: 'hq_lxcg', // 零星采购
	    level: 1,
	    url: '/hq/sign/approval/lxcg/startFlow'
	},
	{
	    name: 'hq_approval_machinery_leasing', // 机械租赁
	    level: 1,
	    url: '/hq/sign/approval/machinery/leasing/startFlow'
	},
	{
	    name: 'hq_approval_maintenance', // 维修保养
	    level: 1,
	    url: '/hq/sign/approval/maintenance/startFlow'
	},
	{
	    name: 'hq_approval_material_procurement', // 物料采购
	    level: 1,
	    url: '/hq/sign/approval/material/procurement/startFlow'
	},
	{
	    name: 'hq_approval_other', // 其他
	    level: 1,
	    url: '/hq/sign/approval/other/startFlow'
	},
	{
	    name: 'hq_approval_price_compare', // 比价
	    level: 1,
	    url: '/hq/sign/approval/price/compare/startFlow'
	},
	{
	    name: 'hq_approval_project_credits', // 工程抵款
	    level: 1,
	    url: '/hq/sign/approval/project/credits/startFlow'
	},
    {
        name: 'aams_reg_seal_usage_approval', // 用印审批
        level: 1,
        url: '/seal/aamsRegSealUsageApproval/startFlow'
    },
    {
        name: 'aams_reg_seal_engrave_approval', // 印章刻制审批
        level: 1,
        url: '/seal/aamsRegSealEngraveApproval/startFlow'
    },
    {
        name: 'aams_reg_seal_engrave_record', // 印章刻制信息登记
        level: 1,
        url: '/seal/aamsRegSealEngraveRecord/startFlow'
    },
    {
        name: 'aams_reg_seal_auth_approval', // 印章授权审批
        level: 1,
        url: '/seal/aamsRegSealAuthApproval/startFlow'
    },
    {
        name: 'aams_reg_seal_auth_record', // 印章授权信息登记
        level: 1,
        url: '/seal/aamsRegSealAuthRecord/startFlow'
    },
    {
        name: 'aams_reg_seal_disposal_approval', // 印章废止
        level: 1,
        url: '/seal/aamsRegSealDisposalApproval/startFlow'
    },
    {
        name: 'aams_reg_seal_disposal_record', // 印章废止
        level: 1,
        url: '/seal/aamsRegSealDisposalRecord/startFlow'
    },
    {
        name: 'aams_reg_seal_usage_record', // 印章使用信息登记
        level: 1,
        url: '/seal/aamsRegSealUsageRecord/startFlow'
    },
    {
        name: 'aams_reg_seal_incident_report', // 印章使用信息登记
        level: 1,
        url: '/seal/aamsRegSealIncidentReport/startFlow'
    },
    {
        name: 'aams_reg_seal_annual_record', // 印章使用信息登记
        level: 1,
        url: '/seal/aamsRegSealAnnualRecord/startFlow'
    },
    {
        name: 'aams_base_seal_category',
        level: 1,
        url: '/base/aamsBaseSealCategory/startFlow'
    },
    {
        name: 'aams_base_seal_reason_category', 
        level: 1,
        url: '/base/aamsBaseSealReasonCategory/startFlow'
    },
    {
        name: 'aams_base_seal_approval_permission', // 印章审批权限
        level: 1,
        url: '/base/aamsBaseSealApprovalPermission/startFlow'
    },
    {
        name: 'aams_base_seal_catalog_register', // 印章目录注册
        level: 1,
        url: '/base/aamsBaseSealCatalogRegister/startFlow'
    },
    {
        name: 'aams_reg_seal_auth_record_recall', // 印章授权收回
        level: 1,
        url: '/seal/aamsRegSealAuthRecord/startFlowRecall'
    },
    // 企业管理
    {
        name: 'cms_base_type',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_annual',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_zsku',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_work_plan',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_work_daily',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_base_sop_type',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_sop_content_pre',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_sop_content',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_integrity_info',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_integrity_educate',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_safe_educate',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_safe_sign',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_safe_check',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_safe_accident',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_insure_content_pre',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_insure_content',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_insure_claim',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_affair',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_crisis',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_attend_pre',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_attend_content',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_work_finish',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_work_plan_adjust',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_work_perf',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_work_check',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_meeting_pre',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_meeting',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_meeting_dept',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_talk',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_talk_contact',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_suggest',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_obstacle_info',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_obstacle_pre',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_obstacle',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    {
        name: 'cms_regist_team',
        level: 1,
        url: '/cms/flow/startFlow'
    },
    // 企业管理-用户权限分配管理
    {
        name: 'cms_icm_role_allo',
        level: 1,
        url: '/cms/flow/startFlowCms'
    },
    {
        name: 'cms_icm_role_allo_pre',
        level: 1,
        url: '/cms/flow/startFlowCms'
    },
    {
        name: 'cms_icm_role_name',
        level: 1,
        url: '/cms/flow/startFlowCms'
    },
    {
        name: 'cms_icm_standard',
        level: 1,
        url: '/cms/flow/startFlowCms'
    },
    // 内控管理
    {
        name: 'erp_icm_backup_media',
        level: 1,
        url: '/erp/icm/backupMedia/startFlow'
    },
    {
        name: 'erp_icm_backup_type',
        level: 1,
        url: '/erp/icm/backupType/startFlow'
    },
    {
        name: 'erp_icm_db_backup',
        level: 1,
        url: '/erp/icm/dbBackup/startFlow'
    },
    {
        name: 'erp_icm_db_backup_check',
        level: 1,
        url: '/erp/icm/dbBackupCheck/startFlow'
    },
    {
        name: 'erp_icm_room_access',
        level: 1,
        url: '/erp/icm/roomAccess/startFlow'
    },
    {
        name: 'erp_icm_room_access_info',
        level: 1,
        url: '/erp/icm/roomAccessInfo/startFlow'
    },
    {
        name: 'erp_icm_room_equip_adjust',
        level: 1,
        url: '/erp/icm/roomEquipAdjust/startFlow'
    },
    {
        name: 'erp_icm_room_equip_adjust_info',
        level: 1,
        url: '/erp/icm/roomEquipAdjustInfo/startFlow'
    },
    {
        name: 'erp_icm_db_data_use',
        level: 1,
        url: '/erp/icm/dbDataUse/startFlow'
    },
    {
        name: 'erp_icm_db_data_use_info',
        level: 1,
        url: '/erp/icm/dbDataUseInfo/startFlow'
    },
    // 资金管理
    {
        name: 'funds_account_open',
        level: 1,
        url: '/funds/fundsAccountOpen/startFlow'
    },
    {
        name: 'funds_account_open_info',
        level: 1,
        url: '/funds/fundsAccountOpenInfo/startFlow'
    },
    {
        name: 'funds_bank',
        level: 1,
        url: '/funds/fundsBank/startFlow'
    },
    {
        name: 'funds_account_cancel',
        level: 1,
        url: '/funds/fundsAccountCancel/startFlow'
    },
    // 人力资源
    {
        name: 'hr_hire_adjust_org',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_salary_rank_grant_adjust',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_basic_corp',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_corp_his',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_corp_temp',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_org',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_org_his',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_org_temp',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_station',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_station_his',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_basic_station_temp',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_adm_compete',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_adm_compete_score',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_adm_cadre',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_adm_experte',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_adm_dispute',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_regist_school',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_regist_web',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_regist_work',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_regist_plan',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_regist_plan_his',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_regist_plan_temp',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_person',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_employee',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_employee_regular',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_adjust_orgrel',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_employee_leave',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_hire_track',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_dossier_info',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_dossier_consult',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_dossier_destory',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_employee_contract',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_employee_contract_his',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_employee_contract_temp',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_institute',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_lecturer',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_service_pro',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_attend',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_pro',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_cert_profession',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_cert_prac',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_train_cert_special',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_charge',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_promise',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_promise_adjust',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_promise_check',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_appraise_self',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_appraise',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_daily_reward',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_salary_regist_holiday',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_salary_regist_roster',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_salary_regist_workarea',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_salary_regist_attn',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_salary_rank_grant',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_calc_actual',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_calc_special',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_calc_compensate',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_calc_leave',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_employee_bank',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_grant',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_perf_promise_score',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_bonus_theory',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_bonus_bal',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_bonus_tax',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_bonus_actual',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_bonus_team',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_bonus_individ',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_ins_social',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_ins_social_adjust',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_weal_heal',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_calc_social',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_calc_gjj',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_ins_injury',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_ins_bear',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_weal_std',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_weal_biz',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_weal_biz_claim',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_labor',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_salary_labor_fee',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_employee_retire',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'hr_employee_retire_regist',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    {
        name: 'sys_dict_value',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_perf_promise_template',
        level: 1,
        url: '/hr/comm/flow/startFlows'
    },
    {
        name: 'hr_param_holiday',
        level: 1,
        url: '/hr/comm/flow/startFlows'
    },
    {
        name: 'hr_param_duty',
        level: 1,
        url: '/hr/comm/flow/startFlows'
    },
    {
        name: 'hr_param_percent',
        level: 1,
        url: '/hr/comm/flow/startFlows'
    },
    {
        name: 'hr_adm_appeal',
        level: 1,
        url: '/hr/comm/flow/startFlow'
    },
    {
        name: 'hr_salary_ins_batch',
        level: 1,
        url: '/hr/comm/flow/startFlowSalary'
    },
    // 企业登记
    {
        name: 'aams_enterprise_reg_approval',
        level: 1,
        url: '/enterprise/reg/aamsEnterpriseRegApproval/startFlow'
    },
    {
        name: 'aams_enterprise_reg_info',
        level: 1,
        url: '/enterprise/reg/aamsEnterpriseRegInfo/startFlow'
    },
    // 资质管理
    {
        name: 'aams_qualification_reg_approval',
        level: 1,
        url: '/qualification/reg/aamsQualificationRegApproval/startFlow'
    },
    {
        name: 'aams_qualification_reg_info',
        level: 1,
        url: '/qualification/reg/aamsQualificationRegInfo/startFlow'
    },
    {
        name: 'aams_qualification_reg_change',
        level: 1,
        url: '/qualification/reg/aamsQualificationRegChange/startFlow'
    },
    // 年检
    {
        name: 'aams_inspection_reg_approval',
        level: 1,
        url: '/inspection/reg/aamsInspectionRegApproval/startFlow'
    },
    {
        name: 'aams_inspection_reg_info',
        level: 1,
        url: '/inspection/reg/aamsInspectionRegInfo/startFlow'
    },
    // 证照
    {
        name: 'aams_license_reg_info',
        level: 1,
        url: '/license/reg/aamsLicenseRegInfo/startFlow'
    },
    {
        name: 'aams_license_reg_usage_approval',
        level: 1,
        url: '/license/reg/aamsLicenseRegUsageApproval/startFlow'
    },
    {
        name: 'aams_license_reg_usage_info',
        level: 1,
        url: '/license/reg/aamsLicenseRegUsageInfo/startFlow'
    },
    {
        name: 'aams_license_reg_estate_info',
        level: 1,
        url: '/license/reg/aamsLicenseRegEstateInfo/startFlow'
    },
    // 礼物
    {
        name: 'aams_gift_reg_submission',
        level: 1,
        url: '/gift/reg/aamsGiftRegSubmission/startFlow'
    },
    {
        name: 'aams_gift_reg_purchase_approval',
        level: 1,
        url: '/gift/reg/aamsGiftRegPurchaseApproval/startFlow'
    },
    {
        name: 'aams_gift_reg_in_storage',
        level: 1,
        url: '/gift/reg/aamsGiftRegInStorage/startFlow'
    },
    {
        name: 'aams_gift_reg_usage_approval',
        level: 1,
        url: '/gift/reg/aamsGiftRegUsageApproval/startFlow'
    },
    {
        name: 'aams_gift_reg_out_storage',
        level: 1,
        url: '/gift/reg/aamsGiftRegOutStorage/startFlow'
    },
    {
        name: 'aams_gift_reg_out_storage_return',
        level: 1,
        url: '/gift/reg/aamsGiftRegOutStorageReturn/startFlow'
    },
    {
        name: 'aams_gift_reg_inventory_check',
        level: 1,
        url: '/gift/reg/aamsGiftRegInventoryCheck/startFlow'
    },
    // 出差
    {
        name: 'aams_travel_reg_approval',
        level: 1,
        url: '/travel/reg/aamsTravelRegApproval/startFlow'
    },
    {
        name: 'aams_travel_reg_info',
        level: 1,
        url: '/travel/reg/aamsTravelRegInfo/startFlow'
    },
    // 接待
    {
        name: 'aams_reception_reg_approval',
        level: 1,
        url: '/reception/reg/aamsReceptionRegApproval/startFlow'
    },
    {
        name: 'aams_reception_reg_info',
        level: 1,
        url: '/reception/reg/aamsReceptionRegInfo/startFlow'
    },
    // 投诉
    {
        name: 'aams_complaint_reg_approval',
        level: 1,
        url: '/complaint/reg/aamsComplaintRegApproval/startFlow'
    },
    {
        name: 'aams_complaint_reg_info',
        level: 1,
        url: '/complaint/reg/aamsComplaintRegInfo/startFlow'
    },
    // 介绍信
    {
        name: 'aams_letter_usage_approval',
        level: 1,
        url: '/aams/letter/aamsLetterUsageApproval/startFlow'
    },
    {
        name: 'aams_letter_usage_record',
        level: 1,
        url: '/aams/letter/aamsLetterUsageRecord/startFlow'
    },
    // 公文
    {
        name: 'aams_document_reg_dispatch_approval',
        level: 1,
        url: '/document/reg/aamsDocumentRegDispatchApproval/startFlow'
    },
    {
        name: 'aams_document_reg_dispatch_info',
        level: 1,
        url: '/document/reg/aamsDocumentRegDispatchInfo/startFlow'
    },
    {
        name: 'aams_document_reg_receive_info',
        level: 1,
        url: '/document/reg/aamsDocumentRegReceiveInfo/startFlow'
    },
    {
        name: 'aams_document_reg_cancel_approval',
        level: 1,
        url: '/document/reg/aamsDocumentRegCancelApproval/startFlow'
    },
    {
        name: 'aams_document_reg_cancel_info',
        level: 1,
        url: '/document/reg/aamsDocumentRegCancelInfo/startFlow'
    },
    // 法务
    {
        name: 'lams_reg_legal_doc',
        level: 1,
        url: '/reg/lamsRegLegalDoc/startFlow'
    },
    {
        name: 'lams_reg_legal_adviser_approval',
        level: 1,
        url: '/lams/reg/lamsRegLegalAdviserApproval/startFlow'
    },
    {
        name: 'lams_reg_legal_adviser',
        level: 1,
        url: '/lams/reg/lamsRegLegalAdviser/startFlow'
    },
    {
        name: 'lams_reg_legal_consult_approval',
        level: 1,
        url: '/reg/lamsRegLegalConsultApproval/startFlow'
    },
    {
        name: 'lams_reg_legal_consult_info',
        level: 1,
        url: '/reg/lamsRegLegalConsultInfo/startFlow'
    },
    {
        name: 'lams_reg_legal_consult_summary',
        level: 1,
        url: '/reg/lamsRegLegalConsultSummary/startFlow'
    },
    {
        name: 'lams_reg_legal_opinion',
        level: 1,
        url: '/reg/lamsRegLegalOpinion/startFlow'
    },
    {
        name: 'lams_reg_legal_annual_report',
        level: 1,
        url: '/reg/lamsRegLegalAnnualReport/startFlow'
    },
    {
        name: 'lams_reg_legal_doc_review',
        level: 1,
        url: '/reg/lamsRegLegalDocReview/startFlow'
    },
    {
        name: 'lams_reg_legal_litigation_process',
        level: 1,
        url: '/reg/lamsRegLegalLitigationProcess/startFlow'
    },
    {
        name: 'lams_reg_legal_litigation_info',
        level: 1,
        url: '/reg/lamsRegLegalLitigationInfo/startFlow'
    },
    {
        name: 'lams_reg_legal_training',
        level: 1,
        url: '/reg/lamsRegLegalTraining/startFlow'
    },
    {
        name: 'lams_reg_legal_litigation_info_execution_track',
        level: 1,
        url: '/reg/lamsRegLegalLitigationInfoExecutionTrack/startFlow'
    },
    // 授权委托
    {
        name: 'lams_auth_reg_approval',
        level: 1,
        url: '/auth/reg/lamsAuthRegApproval/startFlow'
    },
    {
        name: 'lams_auth_reg_record',
        level: 1,
        url: '/auth/reg/lamsAuthRegRecord/startFlow'
    },
    {
        name: 'lams_auth_reg_accident_record',
        level: 1,
        url: '/auth/reg/lamsAuthRegAccidentRecord/startFlow'
    },
    // 档案
    {
        name: 'arms_reg_archive_approval',
        level: 1,
        url: '/arms/reg/armsRegArchiveApproval/startFlow'
    },
    {
        name: 'arms_reg_archive_filing_info',
        level: 1,
        url: '/arms/reg/armsRegArchiveFilingInfo/startFlow'
    },
    {
        name: 'arms_reg_archive_usage_info',
        level: 1,
        url: '/arms/reg/armsRegArchiveUsageInfo/startFlow'
    },
    {
        name: 'arms_reg_archive_return_info',
        level: 1,
        url: '/arms/reg/armsRegArchiveReturnInfo/startFlow'
    },
    {
        name: 'arms_reg_archive_loss_info',
        level: 1,
        url: '/arms/reg/armsRegArchiveLossInfo/startFlow'
    },
    {
        name: 'arms_reg_archive_completion_info',
        level: 1,
        url: '/arms/reg/armsRegArchiveCompletionInfo/startFlow'
    },
    {
        name: 'arms_base_archive_catalog',
        level: 1,
        url: '/arms/base/armsBaseArchiveCatalog/startFlow'
    },
    {
        name: 'arms_base_archive_category',
        level: 1,
        url: '/arms/base/armsBaseArchiveCategory/startFlow'
    },
    {
        name: 'arms_base_archive_filing_reference',
        level: 1,
        url: '/arms/base/armsBaseArchiveFilingReference/startFlow'
    },
    {
        name: 'arms_base_archive_location',
        level: 1,
        url: '/arms/base/armsBaseArchiveLocation/startFlow'
    },
    {
        name: 'arms_base_confidential_level',
        level: 1,
        url: '/arms/base/armsBaseConfidentialLevel/startFlow'
    },
    {
        name: 'arms_base_project_catalog',
        level: 1,
        url: '/arms/base/armsBaseProjectCatalog/startFlow'
    },
    {
        name: 'arms_reg_archive_destruction_info',
        level: 1,
        url: '/arms/reg/armsRegArchiveDestructionInfo/startFlow'
    },
    {
        name: 'its_sales_reg',
        level: 1,
        url: '/its/sales/itsSalesReg/startFlow'
    },
    // 后勤管理
    {
        name: 'hqgl_zc_base_class',
        level: 1,
        url: '/hqgl/base/class/startFlow'
    },
    {
        name: 'hqgl_zc_base_variety',
        level: 1,
        url: '/hqgl/base/variety/startFlow'
    },
    {
        name: 'hqgl_zc_base_code_rules',
        level: 1,
        url: '/hqgl/base/code/rules/startFlow'
    },
    {
        name: 'hqgl_zc_gouzhi_main',
        level: 1,
        url: '/hqgl/approval/pay/audit/startFlow'
    },
    {
        name: 'hqgl_zc_inputmain',
        level: 1,
        url: '/hqgl/approval/inbound/startFlow'
    },
    {
        name: 'hqgl_zc_chuzhisp',
        level: 1,
        url: '/hqgl/approval/dispose/startFlow'
    },
    {
        name: 'hqgl_zc_chuzhi_info',
        level: 1,
        url: '/hqgl/approval/dispose/information/startFlow'
    },
    {
        name: 'hqgl_zc_fixregmain',
        level: 1,
        url: '/hqgl/approval/fix/startFlow'
    },
    {
        name: 'hqgl_zc_fixattach_main',
        level: 1,
        url: '/hqgl/approval/fixAttach/startFlow'
    },
    {
        name: 'hqgl_zc_pandian_x',
        level: 1,
        url: '/hqgl/approval/inventory/startFlow'
    },
    {
        name: 'hqgl_zc_item_sale',
        level: 1,
        url: '/hqgl/approval/item/sale/startFlow'
    },
    {
        name: 'hqgl_zc_item_sale_info',
        level: 1,
        url: '/hqgl/approval/item/sale/info/startFlow'
    },
    {
        name: 'hqgl_zc_transfers',
        level: 1,
        url: '/hqgl/approval/transfers/startFlow'
    },
    {
        name: 'hqgl_zc_jiaofureg_main',
        level: 1,
        url: '/hqgl/swzc/hqglZcJiaofuRegMain/startFlow'
    },
    {
        name: 'hqgl_zc_jiaofusp_main',
        level: 1,
        url: '/hqgl/swzc/hqglZcJiaofuspMain/startFlow'
    },
    {
        name: 'hqgl_item_benefits_class',
        level: 1,
        url: '/hqgl/item/benefits/class/startFlow'
    },
    {
        name: 'hqgl_item_benefits_fee',
        level: 1,
        url: '/hqgl/item/benefits/fee/startFlow'
    },
    {
        name: 'hqgl_item_benefits_grant_audit',
        level: 1,
        url: '/hqgl/item/benefits/grant/startFlow'
    },
    {
        name: 'hqgl_item_benefits_procure_fee',
        level: 1,
        url: '/hqgl/item/benefits/procure/startFlow'
    },
    {
        name: 'hqgl_canteen_base_fee_name',
        level: 1,
        url: '/hqgl/canteen/base/fee/startFlow'
    },
    {
        name: 'hqgl_canteen_fee',
        level: 1,
        url: '/hqgl/canteen/grant/fee/startFlow'
    },
    {
        name: 'hqgl_canteen_grant_fee',
        level: 1,
        url: '/hqgl/canteen/grant/fee/startFlow'
    },
    {
        name: 'aams_car_base_insurance',
        level: 1,
        url: '/aams/car/base/aamsCarBaseInsurance/startFlow'
    },
    {
        name: 'hqgl_car_fee_subsidy',
        level: 1,
        url: '/hqgl/car/reg/fee/subsidy/startFlow'
    },
    {
        name: 'hqgl_car_fee_subsidy_info',
        level: 1,
        url: '/hqgl/car/reg/subsidy/info/startFlow'
    },
    {
        name: 'hqgl_car_fee_standard',
        level: 1,
        url: '/hqgl/car/reg/fee/standard/startFlow'
    },
    {
        name: 'hqgl_company_car_borrow_audit',
        level: 1,
        url: '/hqgl/car/reg/carBorrow/audit/startFlow'
    },
    {
        name: 'hqgl_company_car_borrow_info',
        level: 1,
        url: '/hqgl/car/reg/carBorrow/info/startFlow'
    },
    {
        name: 'aams_car_reg_car',
        level: 1,
        url: '/aams/car/reg/aamsCarRegCar/startFlow'
    },
    {
        name: 'hqgl_car_reg_card_recharge',
        level: 1,
        url: '/hqgl/car/reg/card/recharge/startFlow'
    },
    {
        name: 'hqgl_company_car_claims',
        level: 1,
        url: '/hqgl/car/reg/claims/startFlow'
    },
    {
        name: 'hqgl_company_car_daily_fee',
        level: 1,
        url: '/hqgl/car/reg/carBorrow/info/startFlow'
    },
    {
        name: 'hqgl_company_car_use_info',
        level: 1,
        url: '/hqgl/car/reg/useInfo/startFlow'
    },
    {
        name: 'hqgl_company_car_insurance_fee',
        level: 1,
        url: '/hqgl/car/reg/insurance/fee/startFlow'
    },
    {
        name: 'hqgl_company_car_fix_audit',
        level: 1,
        url: '/hqgl/car/reg/carFix/audit/startFlow'
    },
    {
        name: 'hqgl_company_car_fix_info',
        level: 1,
        url: '/hqgl/car/reg/fixInfo/startFlow'
    },
    {
        name: 'hqgl_company_data_storage',
        level: 1,
        url: '/hqgl/car/reg/dataStorage/startFlow'
    },
    {
        name: 'hqgl_company_car_hygiene_check',
        level: 1,
        url: '/hqgl/car/reg/hygiene/check/startFlow'
    },
    {
        name: 'hqgl_company_car_card_recharge',
        level: 1,
        url: '/hqgl/car/reg/year/audit/startFlow'
    },
    {
        name: 'hqgl_computer_network_info',
        level: 1,
        url: '/hqgl/computer/network/check/startFlow'
    },
    {
        name: 'hqgl_base_computer_setting',
        level: 1,
        url: '/hqgl/computer/network/info/startFlow'
    },
    {
        name: 'hqgl_computer_use_info',
        level: 1,
        url: '/hqgl/computer/use/info/startFlow'
    },
    {
        name: 'hqgl_mail_receive_info',
        level: 1,
        url: '/logistics/mail/send/info/startFlow'
    },
    {
        name: 'hqgl_mail_send_audit',
        level: 1,
        url: '/logistics/mail/send/audit/startFlow'
    },
    {
        name: 'hqgl_mail_send_info',
        level: 1,
        url: '/logistics/mail/send/info/startFlow'
    },
    {
        name: 'hqgl_office_rules_electric_fee',
        level: 1,
        url: '/hqgl/office/rules/electric/startFlow'
    },
    {
        name: 'hqgl_office_base_rules_fee',
        level: 1,
        url: '/hqgl/office/rules/base/fee/startFlow'
    },
    {
        name: 'hqgl_office_base_rules_fee_place',
        level: 1,
        url: '/hqgl/office/rules/base/place/startFlow'
    },
    {
        name: 'hqgl_office_rules_water_fee',
        level: 1,
        url: '/hqgl/office/rules/water/startFlow'
    },
    {
        name: 'hqgl_office_rules_wuye_fee',
        level: 1,
        url: '/hqgl/office/rules/wuye/startFlow'
    },
    {
        name: 'hqgl_office_base_board_style',
        level: 1,
        url: '/hqgl/office/base/boardStyle/startFlow'
    },
    {
        name: 'hqgl_office_base_door_style',
        level: 1,
        url: '/hqgl/office/base/doorStyle/startFlow'
    },
    {
        name: 'hqgl_office_base_furniture',
        level: 1,
        url: '/hqgl/office/base/furniture/startFlow'
    },
    {
        name: 'hqgl_office_base_holiday',
        level: 1,
        url: '/hqgl/office/base/holiday/startFlow'
    },
    {
        name: 'hqgl_office_base_info',
        level: 1,
        url: '/hqgl/office/base/info/startFlow'
    },
    {
        name: 'hqgl_office_door_make',
        level: 1,
        url: '/logistics/office/key/receive/audit/startFlow'
    },
    {
        name: 'hqgl_office_key_info',
        level: 1,
        url: '/logistics/office/key/info/startFlow'
    },
    {
        name: 'hqgl_office_key_make_info',
        level: 1,
        url: '/logistics/office/key/makeInfo/startFlow'
    },
    {
        name: 'hqgl_office_key_receive_audit',
        level: 1,
        url: '/logistics/office/key/receive/audit/startFlow'
    },
    {
        name: 'hqgl_office_key_receive_info',
        level: 1,
        url: '/logistics/office/key/receive/audit/startFlow'
    },
    {
        name: 'hqgl_office_notice_content',
        level: 1,
        url: '/logistics/office/notice/content/startFlow'
    },
    {
        name: 'hqgl_office_visitor_reception',
        level: 1,
        url: '/logistics/office/visitor/reception/startFlow'
    },
    {
        name: 'hqgl_tel_fee_detail',
        level: 1,
        url: '/hqgl/fee/detail/startFlow'
    },
    {
        name: 'hqgl_tel_setup_app',
        level: 1,
        url: '/hqgl/tel/hqglTelSetupApp/startFlow'
    },
    {
        name: 'hqgl_tel_setup_reg',
        level: 1,
        url: '/hqgl/setup/reg/startFlow'
    },
    {
        name: 'hqgl_work_lunch',
        level: 1,
        url: '/logistics/work/lunch/startFlow'
    },
    // 业务单位
    {
        name: 'aams_unit_base_category',
        level: 1,
        url: '/unit/base/aamsUnitBaseCategory/startFlow'
    },
    {
        name: 'aams_unit_base_nature',
        level: 1,
        url: '/unit/base/aamsUnitBaseNature/startFlow'
    },
    {
        name: 'aams_unit_reg_info',
        level: 1,
        url: '/unit/reg/aamsUnitRegInfo/startFlow'
    },
    {
        name: 'aams_unit_reg_usage_approval',
        level: 1,
        url: '/unit/reg/aamsUnitRegUsageApproval/startFlow'
    },
    {
        name: 'aams_enterprise_base_category',
        level: 1,
        url: '/enterprise/base/aamsEnterpriseBaseCategory/startFlow'
    },
    {
        name: 'aams_license_base_category',
        level: 1,
        url: '/license/base/aamsLicenseBaseCategory/startFlow'
    },
    {
        name: 'aams_gift_base_category',
        level: 1,
        url: '/gift/base/aamsGiftBaseCategory/startFlow'
    },
    {
        name: 'aams_gift_base_item',
        level: 1,
        url: '/gift/base/aamsGiftBaseItem/startFlow'
    },
    {
        name: 'aams_travel_base_standard',
        level: 1,
        url: '/travel/base/aamsTravelBaseStandard/startFlow'
    },
    {
        name: 'aams_reception_base_standard',
        level: 1,
        url: '/reception/base/aamsReceptionBaseStandard/startFlow'
    },
    {
        name: 'aams_complaint_base_category',
        level: 1,
        url: '/complaint/base/aamsComplaintBaseCategory/startFlow'
    },
    {
        name: 'aams_document_base_category',
        level: 1,
        url: '/document/base/aamsDocumentBaseCategory/startFlow'
    },
    {
        name: 'aams_document_base_dispatch_code',
        level: 1,
        url: '/document/base/aamsDocumentBaseDispatchCode/startFlow'
    },
    {
        name: 'lams_base_legal_category',
        level: 1,
        url: '/base/lamsBaseLegalCategory/startFlow'
    },
    {
        name: 'lams_base_legal_counselor_hire_type',
        level: 1,
        url: '/base/lamsBaseLegalCounselorHireType/startFlow'
    },
    {
        name: 'lams_base_legal_doc_type',
        level: 1,
        url: '/base/lamsBaseLegalDocType/startFlow'
    },
    {
        name: 'lams_base_legal_procedure_level',
        level: 1,
        url: '/base/lamsBaseLegalProcedureLevel/startFlow'
    },
    {
        name: 'lams_base_legal_archive_reference',
        level: 1,
        url: '/base/lamsBaseLegalArchiveReference/startFlow'
    },
    {
        name: 'lams_auth_base_accident_category',
        level: 1,
        url: '/auth/base/lamsAuthBaseAccidentCategory/startFlow'
    },
    {
        name: 'lams_auth_base_category',
        level: 1,
        url: '/auth/base/lamsAuthBaseCategory/startFlow'
    },
    {
        name: 'apms_basic_plant_protection_batch_setting',
        level: 1,
        url: '/apms/basic/apmsBasicPlantProtectionBatchSetting/startFlow'
    },
    {
        name: 'apms_basic_phenophase_category',
        level: 1,
        url: '/apms/basic/apmsBasicPhenophaseCategory/startFlow'
    },
    {
        name: 'apms_basic_farming_category',
        level: 1,
        url: '/apms/basic/apmsBasicFarmingCategory/startFlow'
    },
    {
        name: 'apms_basic_canteen_material_category',
        level: 1,
        url: '/apms/basic/apmsBasicCanteenMaterialCategory/startFlow'
    },
    {
        name: 'apms_basic_image_library_category',
        level: 1,
        url: '/apms/basic/apmsBasicImageLibraryCategory/startFlow'
    },
    {
        name: 'apms_basic_plot_info',
        level: 1,
        url: '/apms/basic/apmsBasicPlotInfo/startFlow'
    },
    {
        name: 'apms_basic_planting_info',
        level: 1,
        url: '/apms/basic/apmsBasicPlantingInfo/startFlow'
    },
    {
        name: 'apms_basic_phenophase_info',
        level: 1,
        url: '/apms/basic/apmsBasicPhenophaseInfo/startFlow'
    },
    {
        name: 'apms_basic_farming_operation',
        level: 1,
        url: '/apms/basic/apmsBasicFarmingOperation/startFlow'
    },
    {
        name: 'apms_basic_canteen_material_info',
        level: 1,
        url: '/apms/basic/apmsBasicCanteenMaterialInfo/startFlow'
    },
    {
        name: 'apms_basic_labor_team',
        level: 1,
        url: '/apms/basic/apmsBasicLaborTeam/startFlow'
    },
    {
        name: 'apms_basic_image_library_info',
        level: 1,
        url: '/apms/basic/apmsBasicImageLibraryInfo/startFlow'
    },
    {
        name: 'apms_basic_tool_info',
        level: 1,
        url: '/apms/basic/apmsBasicToolInfo/startFlow'
    },
    {
        name: 'apms_reg_plant_protection_info',
        level: 1,
        url: '/apms/reg/apmsRegPlantProtectionInfo/startFlow'
    },
    {
        name: 'apms_reg_farming_info',
        level: 1,
        url: '/apms/reg/apmsRegFarmingInfo/startFlow'
    },
    {
        name: 'apms_reg_labor_employment',
        level: 1,
        url: '/apms/reg/apmsRegLaborEmployment/startFlow'
    },
    {
        name: 'apms_reg_thinning_bagging',
        level: 1,
        url: '/apms/reg/apmsRegThinningBagging/startFlow'
    },
    {
        name: 'apms_reg_canteen_purchase',
        level: 1,
        url: '/apms/reg/apmsRegCanteenPurchase/startFlow'
    },
    {
        name: 'apms_reg_canteen_requisition',
        level: 1,
        url: '/apms/reg/apmsRegCanteenRequisition/startFlow'
    },
    {
        name: 'apms_reg_utility_bill',
        level: 1,
        url: '/apms/reg/apmsRegUtilityBill/startFlow'
    },
    {
        name: 'apms_reg_annual_yield_forecast',
        level: 1,
        url: '/apms/reg/apmsRegAnnualYieldForecast/startFlow'
    },
    {
        name: 'apms_reg_tool_in_record',
        level: 1,
        url: '/apms/reg/apmsRegToolInRecord/startFlow'
    },
    {
        name: 'apms_reg_tool_out_record',
        level: 1,
        url: '/apms/reg/apmsRegToolOutRecord/startFlow'
    },
    {
        name: 'apms_reg_tool_return_record',
        level: 1,
        url: '/apms/reg/apmsRegToolReturnRecord/startFlow'
    },
    {
        name: 'apms_reg_tool_lease',
        level: 1,
        url: '/apms/reg/apmsRegToolLease/startFlow'
    },
    {
        name: 'apms_reg_contract_settlement',
        level: 1,
        url: '/apms/reg/apmsRegContractSettlement/startFlow'
    },

    // 企业文化
    {
        name: 'culture_asset_base_class',
        level: 1,
        url: '/culture/asset/baseClass/startFlow'
    },
    {
        name: 'culture_asset_delivery_audit',
        level: 1,
        url: '/culture/asset/delivery/audit/startFlow'
    },
    {
        name: 'culture_asset_delivery_info',
        level: 1,
        url: '/culture/asset/delivery/info/startFlow'
    },
    {
        name: 'culture_asset_dispose_audit',
        level: 1,
        url: '/culture/asset/dispose/audit/startFlow'
    },
    {
        name: 'culture_asset_dispose_info',
        level: 1,
        url: '/culture/asset/dispose/info/startFlow'
    },
    {
        name: 'culture_asset_maintain_audit',
        level: 1,
        url: '/culture/asset/maintain/audit/startFlow'
    },
    {
        name: 'culture_asset_maintain_info',
        level: 1,
        url: '/culture/asset/maintain/info/startFlow'
    },
    {
        name: 'culture_asset_purchase_audit',
        level: 1,
        url: '/culture/asset/purchase/audit/startFlow'
    },
    {
        name: 'culture_asset_purchase_info',
        level: 1,
        url: '/culture/asset/purchase/info/startFlow'
    },
    {
        name: 'culture_asset_register_audit',
        level: 1,
        url: '/culture/asset/register/audit/startFlow'
    },
    {
        name: 'culture_asset_register_info',
        level: 1,
        url: '/culture/asset/register/info/startFlow'
    },
    {
        name: 'culture_asset_utilize_audit',
        level: 1,
        url: '/culture/asset/utilize/audit/startFlow'
    },
    {
        name: 'culture_asset_utilize_info',
        level: 1,
        url: '/culture/asset/utilize/info/startFlow'
    },
    {
        name: 'culture_activity_audit',
        level: 1,
        url: '/culture/activity/audit/startFlow'
    },
    {
        name: 'culture_activity_holiday_type',
        level: 1,
        url: '/culture/activity/holidayType/startFlow'
    },
    {
        name: 'culture_activity_info',
        level: 1,
        url: '/culture/activity/info/startFlow'
    },
    {
        name: 'culture_activity_type',
        level: 1,
        url: '/culture/activity/activityType/startFlow'
    },
    {
        name: 'culture_about_jinqiao_content_okay_audit',
        level: 1,
        url: '/culture/about/jinqiaoContentOkay/startFlow'
    },
    {
        name: 'culture_about_jinqiao_content_use_audit',
        level: 1,
        url: '/culture/about/jinqiaoContentUse/startFlow'
    },
    {
        name: 'culture_about_jinqiao_form_type',
        level: 1,
        url: '/culture/about/jinqiaoFormType/startFlow'
    },
    {
        name: 'culture_about_jinqiao_type',
        level: 1,
        url: '/culture/about/jinqiaoType/startFlow'
    },
    {
        name: 'culture_design_material_borrow_audit',
        level: 1,
        url: '/culture/design/borrow/startFlow'
    },
    {
        name: 'culture_design_material_borrow_info',
        level: 1,
        url: '/culture/design/borrowInfo/startFlow'
    },
    {
        name: 'culture_design_material_inbound_info',
        level: 1,
        url: '/culture/design/inboundInfo/startFlow'
    },
    {
        name: 'culture_design_material_procurement_audit',
        level: 1,
        url: '/culture/design/procurement/startFlow'
    },
    {
        name: 'culture_design_material_type',
        level: 1,
        url: '/culture/design/designMaterialType/startFlow'
    },
    {
        name: 'culture_design_material_year_info',
        level: 1,
        url: '/culture/design/yearInfo/startFlow'
    },
    {
        name: 'culture_new_media_post_audit',
        level: 1,
        url: '/culture/newmedia/post/startFlow'
    },
    {
        name: 'culture_new_media_post_info',
        level: 1,
        url: '/culture/newmedia/post/info/startFlow'
    },
    {
        name: 'culture_new_media_register_audit',
        level: 1,
        url: '/culture/newmedia/register/startFlow'
    },
    {
        name: 'culture_new_media_register_info',
        level: 1,
        url: '/culture/newmedia/register/info/startFlow'
    },
    {
        name: 'culture_promotion_content_post_audit',
        level: 1,
        url: '/culture/promotion/content/post/audit/startFlow'
    },
    {
        name: 'culture_promotion_content_post_info',
        level: 1,
        url: '/culture/promotion/content/post/info/startFlow'
    },
    {
        name: 'culture_promotion_content_type',
        level: 1,
        url: '/culture/promotion/contentType/startFlow'
    },
    {
        name: 'culture_promotion_form_type',
        level: 1,
        url: '/culture/promotion/formType/startFlow'
    },
    {
        name: 'culture_promotion_platform_type',
        level: 1,
        url: '/culture/promotion/platformType/startFlow'
    },
    {
        name: 'culture_vi_image_abolish_audit',
        level: 1,
        url: '/culture/vi/imageAbolishAudit/startFlow'
    },
    {
        name: 'culture_vi_image_abolish_info',
        level: 1,
        url: '/culture/vi/imageAbolishInfo/startFlow'
    },
    {
        name: 'culture_vi_image_app_type',
        level: 1,
        url: '/culture/vi/viImageAppType/startFlow'
    },
    {
        name: 'culture_vi_image_design_audit',
        level: 1,
        url: '/culture/vi/imageDesignAudit/startFlow'
    },
    {
        name: 'culture_vi_image_design_info',
        level: 1,
        url: '/culture/vi/imageDesignInfo/startFlow'
    },
    {
        name: 'culture_vi_image_register_audit',
        level: 1,
        url: '/culture/vi/imageRegisterAudit/startFlow'
    },
    {
        name: 'culture_vi_image_register_info',
        level: 1,
        url: '/culture/vi/imageRegisterInfo/startFlow'
    },
    {
        name: 'culture_vi_image_type',
        level: 1,
        url: '/culture/vi/viImageType/startFlow'
    },

]

export default URLS
